function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_d)"
}, React.createElement("rect", {
  x: 30,
  y: 10,
  width: 501,
  height: 254,
  rx: 15,
  fill: "white"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 71,
  y: 58,
  width: 419,
  height: 19,
  fill: "#F5F4FF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 71,
  y: 58,
  width: 253,
  height: 19,
  fill: "#6F62FF"
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 71,
  y: 104,
  width: 419,
  height: 19,
  fill: "#F5F4FF"
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 71,
  y: 150,
  width: 419,
  height: 19,
  fill: "#F5F4FF"
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 71,
  y: 104,
  width: 347,
  height: 19,
  fill: "#8BCEFF"
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  x: 71,
  y: 150,
  width: 189,
  height: 19,
  fill: "#6F62FF"
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 71,
  y: 196,
  width: 419,
  height: 19,
  fill: "#F5F4FF"
});

var _ref10 =
/*#__PURE__*/
React.createElement("rect", {
  x: 71,
  y: 196,
  width: 306,
  height: 19,
  fill: "#6F62FF"
});

var _ref11 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 561,
  height: 314,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 20
}), React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.261239 0 0 0 0 0.238559 0 0 0 0 0.629167 0 0 0 0.2 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgOnboardingTribes = function SvgOnboardingTribes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 561,
    height: 314,
    viewBox: "0 0 561 314",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOnboardingTribes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/onboardingTribes.5aa94d27.svg";
export { ForwardRef as ReactComponent };